import axios from "axios";

export const state = {
    stockreport: [],
};

export const getters = {
    stockreport: state => state.stockreport,
};

export const mutations = {
    setStockReport(stockreport, newValue) { state.stockreport = newValue},
};

export const actions = {
    fetchStockReport({ commit }) {
        axios.get('/stockreport').then(res => {
            commit('setStockReport', res.data.report)
        })
    },
    filterStockReport({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterstockreport";
        axios.post(url, formData).then((response) => {
            commit('setStockReport', response.data.report)
        })
    },
};
